import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import 'pdfjs-dist/build/pdf.worker.entry';
import nequiButImg from './nequi_but.png';





function NequiPaymentModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm text-center mx-4">
        <h2 className="text-xl font-semibold text-pink-600 mb-3">Confirma tu pago en Nequi 💜</h2>
        <p className="text-gray-700 mb-3">
          1️⃣ Abre tu app <b>Nequi</b>.<br />
          2️⃣ Ve a <b>Notificaciones</b> o <b>Pendientes</b>.<br />
          3️⃣ Acepta la solicitud de pago por el valor indicado.<br />
          4️⃣ Luego regresa a esta página por favor.  
        </p>
        <p className="text-gray-600 text-sm mb-5">
          Si no ves el aviso de inmediato, actualiza tu app o revisa el historial de solicitudes.
        </p>
        <button
          onClick={onClose}
          className="bg-pink-600 text-white px-6 py-2 rounded-xl hover:bg-pink-700 transition"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}


const PAYPAL_CLIENT_ID = 'AZ5xACU0AzYdpYbwnH1eZyz5V4P1Py7fzkrkbCHtN0S1xfrDYZz9zXE1LQhb2FUfDdq4twiW2F1bGziR';

const PLAN_INFO_URL =
  "https://2zyff5s6kpf3ur3otnbqellaby0wkoby.lambda-url.us-east-1.on.aws/";

const PAYPAL_LAMBDA_URL =
  "https://uuyej67fzqonaixlomhzrzzz2m0brlts.lambda-url.us-east-1.on.aws/";



const planesSuscripcion = [
  {
    name: 'Plan Básico',
    duration: 'monthly',
    pages: 500,
    price_cop: 22500,
    precio_por_pagina: 45,
  },
  {
    name: 'Plan Intermedio',
    duration: 'monthly',
    pages: 2000,
    price_cop: 80000,
    precio_por_pagina: 40,
  },
  {
    name: 'Plan Avanzado',
    duration: 'monthly',
    pages: 5000,
    price_cop: 175000,
    precio_por_pagina: 35,
  },
  {
    name: 'Plan Empresarial',
    duration: 'monthly',
    pages: 12000,
    price_cop: 360000,
    precio_por_pagina: 30,
  },

  {
    name: 'Plan Básico',
    duration: 'annual',
    pages: 6000,
    price_cop: 189000,
    precio_por_pagina: 31.5,
  },
  {
    name: 'Plan Intermedio',
    duration: 'annual',
    pages: 24000,
    price_cop: 672000,
    precio_por_pagina: 28,
  },
  {
    name: 'Plan Avanzado',
    duration: 'annual',
    pages: 60000,
    price_cop: 1470000,
    precio_por_pagina: 24.5,
  },
  {
    name: 'Plan Empresarial',
    duration: 'annual',
    pages: 144000,
    price_cop: 3024000,
    precio_por_pagina: 21,
  },
];




function ExtractTextPageLogin() {
  const [pdfPreview, setPdfPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [extractionEnabled, setExtractionEnabled] = useState(false);
  const [pageCount, setPageCount] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [waitingNequi, setWaitingNequi] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { fileURL, pages } = location.state || {};
  const paypalRendered = useRef(false);
  const [nequiPhone, setNequiPhone] = useState('');
  const [transactionId, setTransactionId] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [pushSent, setPushSent] = useState(false);
  const [canCheckStatus, setCanCheckStatus] = useState(false);
  const [showNequiModal, setShowNequiModal] = useState(false);
  const [planInfo, setPlanInfo] =
    useState(null);
  const hasAvailablePages =
    planInfo &&
    (
      planInfo.plan_pages > 0 ||
      planInfo.extra_pages > 0
    );

  


  useEffect(() => {
    const idToken = Cookies.get('idToken');
    if (!idToken) return navigate('/login');
    try {
      const decoded = jwtDecode(idToken);
      setUserEmail(decoded.email);
    } catch (err) {
      navigate('/login');
    }
  }, [navigate]);

  const fetchPlanInfo =
    async () => {

    try {

      const token =
        Cookies.get(
          "accessToken"
        );

      const res =
        await axios.get(
          PLAN_INFO_URL,
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );

      setPlanInfo(res.data);

    } catch (err) {

      console.error(
        "Error plan info:",
        err
      );
    }
  };

  useEffect(() => {

    fetchPlanInfo();

  }, []);

  useEffect(() => {
    if (!fileURL) navigate('/');
    else {
      setPdfPreview(fileURL);
      if (pages) setPageCount(pages);
      else countPDFPages(fileURL);
    }
  }, [fileURL, pages, navigate]);

  useEffect(() => {
    if (!waitingNequi || !transactionId) return;

    const interval = setInterval(() => {
      checkPaymentStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [waitingNequi, transactionId]);




  const countPDFPages = async (pdfUrl) => {
    try {
      const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
      setPageCount(pdf.numPages);
    } catch {
      setPageCount(null);
    }
  };

  const extractFileKey = (url) => {
    try {
      const urlObj = new URL(url);
      return decodeURIComponent(urlObj.pathname.split('/').slice(2).join('/'));
    } catch {
      return null;
    }
  };

  

  const handlePagoPorPaginaNequi = () => {
    if (!pageCount) return alert('No se pudo obtener el número de páginas.');

    const getPricePerPage = (pages) => {

      if (pages >= 1000) return 35;
      if (pages >= 500) return 40;
      if (pages >= 100) return 45;

      return 50;
    };

    const pricePerPage =
      getPricePerPage(pageCount);

    const totalPriceCOP =
      (pageCount * pricePerPage)
        .toString();
    setSelectedOption({
      name: 'Pago por página (Nequi)',
      price: totalPriceCOP,
      pages: pageCount,
      currency: 'COP',
      type: 'PAY_PER_PAGE' // 🔥 CLAVE
    });
  };

  const handlePagoPorPaginaPaypal = () => {

  if (!pageCount) {
    alert("No se pudo obtener el número de páginas.");
    return;
  }

  const getPricePerPage = (pages) => {

    if (pages >= 1000) return 35;
    if (pages >= 500) return 40;
    if (pages >= 100) return 45;

    return 50;
  };

  const pricePerPage =
    getPricePerPage(pageCount);

  const totalCOP =
    pageCount * pricePerPage;

  const totalUSD =
    (totalCOP / 4500)
      .toFixed(2);

  setSelectedOption({
    name: "Pago por página PayPal",
    price: totalUSD,
    pages: pageCount,
    currency: "USD",
    type: "PAY_PER_PAGE"
  });
};

  const handlePlanSeleccionado = (
    plan,
    metodo = "nequi"
  ) => {

    setSelectedOption({
      ...plan,

      currency:
        metodo === "paypal"
          ? "USD"
          : "COP",

      type: "PLAN"
    });
  };

  const parseJwt = (token) => {
    try {
      return JSON.parse(
        atob(token.split('.')[1])
      );
    } catch (e) {
      return null;
    }
  };


  useEffect(() => {

    if (
      !selectedOption ||
      selectedOption.currency !== "USD"
    ) {
      return;
    }

    paypalRendered.current = false;

    const existingScript =
      document.querySelector(
        'script[src*="paypal.com/sdk/js"]'
      );

    if (!existingScript) {

      const script =
        document.createElement("script");

      script.src =
        `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}`;

      script.async = true;

      script.onload =
        renderPaypalButtons;

      document.body.appendChild(
        script
      );

    } else {

      renderPaypalButtons();
    }

    async function renderPaypalButtons() {

      if (
        paypalRendered.current ||
        !window.paypal
      ) {
        return;
      }

      paypalRendered.current = true;

      document.getElementById(
        "paypal-button-container"
      ).innerHTML = "";

      window.paypal.Buttons({

        createOrder: async () => {

          const token =
            Cookies.get(
              "accessToken"
            );

          const response =
            await axios.post(
              PAYPAL_LAMBDA_URL,
              {
                action:
                  "createOrder",

                payment_type:
                  selectedOption.type,

                pages:
                  selectedOption.pages,

                pages_available:
                  selectedOption.pages,

                plan_type:
                  selectedOption.name,

                amount:
                  selectedOption.price
              },
              {
                headers: {
                  Authorization:
                    `Bearer ${token}`
                }
              }
            );

          return response.data.orderId;
        },

        onApprove: async (
          data
        ) => {

          const token =
            Cookies.get(
              "accessToken"
            );

          const response =
            await axios.post(
              PAYPAL_LAMBDA_URL,
              {
                action:
                  "captureOrder",

                orderId:
                  data.orderID,

                payment_type:
                  selectedOption.type,

                pages:
                  selectedOption.pages,

                pages_available:
                  selectedOption.pages,

                plan_type:
                  selectedOption.name
              },
              {
                headers: {
                  Authorization:
                    `Bearer ${token}`
                }
              }
            );

          if (
              response.data.status ===
              "COMPLETED"
            ) {

              setTransactionId(
                response.data.orderId
              );

              await fetchPlanInfo();

              setExtractionEnabled(
                true
              );

              alert(
                "✅ Pago aprobado"
              );
            }
        },

        onError: (err) => {

          console.error(err);

          alert(
            "Error procesando PayPal"
          );
        }

      }).render(
        "#paypal-button-container"
      );
    }

  }, [selectedOption]);

  const handleNequiPayment = async () => {
    const accessToken = Cookies.get("accessToken");
    if (!selectedOption) {
      alert("Debes seleccionar un plan o pago por página");
      return;
    }
    if (!nequiPhone || nequiPhone.length !== 10) {
      alert("Número Nequi inválido");
      return;
    }

    try {
      setWaitingNequi(true);
      setShowNequiModal(true);

      const isPlan =
        selectedOption?.type === "PLAN";

      let payload;

      if (isPlan) {
        payload = {
          plan_type: selectedOption.name,
          pages_available: selectedOption.pages,
          payment_method: "nequi",
          phoneNumber: nequiPhone,
          payment_value: Number(selectedOption.price),
        };
      } else {
        payload = {
          payment_method: "nequi",
          phoneNumber: nequiPhone,
          payment_value: Number(selectedOption.price),
          pages: selectedOption.pages
        };
      }

      

      const res = await axios.post(
        "https://jb4ogkdasqbrkiefenygi3tzyy0vnwcg.lambda-url.us-east-1.on.aws/",
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      setTransactionId(res.data.transactionId);
      

      

      alert("📲 Solicitud enviada a tu app Nequi");
      
      setPushSent(true);
      setCanCheckStatus(false);

      setTimeout(() => {
        setCanCheckStatus(true);
      }, 6000); // 6 segundos reales para que Nequi procese



    } catch (err) {
      console.error(err);
      alert("Error enviando pago Nequi");
      setWaitingNequi(false);
    }
  };

  /* =========================
     Pago Nequi (ESTADO)
  ========================= */
 const checkPaymentStatus = async () => {
  if (!transactionId) {
    alert("No hay transacción");
    return;
  }
  if (transactionId.startsWith("TEST_")) {
    console.log("🧪 SANDBOX FRONT: pago aprobado automático");

    await fetchPlanInfo();
    setExtractionEnabled(true);
    setWaitingNequi(false);
    setShowNequiModal(false);
    setPushSent(false);
    setNequiPhone('');

    return;
  }

  try {
    setCheckingStatus(true);

    const token = Cookies.get("accessToken");
    const idToken = Cookies.get("idToken");

    const payload = parseJwt(idToken);
    const email = payload?.email;

    if (!email) {
      alert("No se pudo obtener el email del usuario");
      return;
    }

    const res = await fetch(
      "https://oy65sm3fdom2u5ot3gk5xez7we0otgnr.lambda-url.us-east-1.on.aws/",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transactionId,
          email, // ✅ AHORA SÍ
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      console.error("Error Lambda:", data);
      alert(data.error || "Error consultando estado");
      return;
    }

    const estado =
      data.estado ||
      data.nequiPushResult?.status ||
      data.nequiPushResult?.state;

    if (!estado) {
      console.log("⏳ Aún sin estado definitivo:", data);
      
      return;
    }

    if (estado === "APPROVED") {
      await fetchPlanInfo();
      alert("✅ Pago aprobado");
      setExtractionEnabled(true);
      setWaitingNequi(false);
      setCanCheckStatus(false);
      setShowNequiModal(false); 
      setPushSent(false);
      setNequiPhone('');
    } else if (estado === "PENDING") {
      console.log("⏳ Aún pendiente en Nequi");
    } else if (estado === "REJECTED") {
      alert("❌ Pago rechazado");
      setWaitingNequi(false);
    } else if (estado === "EXPIRED") {
      alert("⌛ Pago expirado");
      setWaitingNequi(false);
    }
  } catch (err) {
    console.error(err);
    alert("Error consultando estado");
  } finally {
    setCheckingStatus(false);
  }
};





const handleExtractText = async () => {
  if (
  !extractionEnabled &&
  !hasAvailablePages
  ) return alert('Debes realizar el pago antes de extraer el texto.');
  setLoading(true);

  try {
    if (!pageCount) {
      throw new Error("No se pudo determinar número de páginas");
    }

    const key = extractFileKey(fileURL);
    if (!key) throw new Error('No se pudo obtener la clave del archivo.');

    const fileNameOnly = key.split('/').pop();

    const usingAccountPages =
      hasAvailablePages;

    const isPlan =
      selectedOption?.type === "PLAN"
      || usingAccountPages;

    if (!isPlan &&!transactionId) {
      throw new Error("No hay transaction_id");
    }

   

    let payload;

    if (isPlan) {
      payload = {
        fileName: fileNameOnly,
        payment_mode: "PLAN",
        pages: pageCount
      };
    } else {
      payload = {
        fileName: fileNameOnly,
        payment_mode: "PAY_PER_PAGE",
        transaction_id: transactionId,
        pages: pageCount
      };
    }

    console.log("ENVIANDO:", payload);

    const response = await axios.post(
      'https://yi2dgtfdembaun6bmdpvcgxbku0nyjsq.lambda-url.us-east-1.on.aws/',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }
    );

    const data = response.data.body ? JSON.parse(response.data.body) : response.data;

    if (!data.txtDownloadUrl) throw new Error('No se recibió la URL');

    await fetchPlanInfo();
    
    navigate('/downloadtextpagelogin', {
      state: {
        email: userEmail,
        fileKey: key,
        txtDownloadUrl: data.txtDownloadUrl,
        docDownloadUrl: data.docDownloadUrl,
        pages: data.pages,
      },
    });

  } catch (err) {
    console.error(err);
    alert(err.message || 'Error durante la extracción');
  } finally {
    setLoading(false);
  }
};



  const planesNequi = planesSuscripcion.map(plan => ({
    name: `${plan.name} (${plan.duration === 'monthly' ? 'Mensual' : 'Anual'})`,
    price: plan.price_cop,
    priceLabel: plan.price_cop.toLocaleString(),
    pages: plan.pages,
    precio_por_pagina: +(plan.price_cop / plan.pages).toFixed(1),
    type: 'PLAN' // 🔥 AÑADE ESTO
  }));


  const planesPaypal = planesSuscripcion.map(plan => {
    const priceUSD = (plan.price_cop / 4500).toFixed(2);
    return {
      name: `${plan.name} (${plan.duration === 'monthly' ? 'Mensual' : 'Anual'}) - ${plan.pages} páginas`,
      price: priceUSD,
      pages: plan.pages
    };
  });

  // 🔍 Verificar estado real del pago en Nequi





  return (
  <div className="p-6 md:p-10 max-w-7xl mx-auto text-center">
    <h1 className="text-3xl md:text-4xl font-bold text-blue-600 mb-8">
      Extracción de Texto desde PDF
    </h1>

    {hasAvailablePages ? (

      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-6 mb-8 shadow">

        <h2 className="text-2xl font-bold text-blue-900 mb-3">

          {planInfo.plan_pages > 0
            ? `📦 Plan ${planInfo.plan_type} activo`
            : "🎁 Trial activo"}

        </h2>

        <div className="text-gray-700 space-y-2">

          {planInfo.plan_pages > 0 && (
              <p>
                Páginas del plan:
                <strong>
                  {" "}
                  {planInfo.plan_pages}
                </strong>
              </p>
            )}

            {planInfo.extra_pages > 0 && (
              <p>
                Páginas extra:
                <strong>
                  {" "}
                  {planInfo.extra_pages}
                </strong>
              </p>
            )}

          <p>
            Estado:
            <strong>
              {" "}
              {planInfo.status}
            </strong>
          </p>

          <p>
            Vence:
            <strong>
              {" "}
              {new Date(
                planInfo.expires_at
              ).toLocaleDateString()}
            </strong>
          </p>

        </div>

        <div className="mt-5 text-green-700 font-semibold text-lg">

          ✅ Ya puedes extraer PDFs sin realizar otro pago.

        </div>

      </div>

    ) : (

    <>

    <div className="flex flex-col md:flex-row justify-center gap-4 mb-8">

  {/* Nequi */}
      <button
        onClick={handlePagoPorPaginaNequi}
        className="bg-pink-500 text-white px-6 py-3 rounded-xl shadow hover:bg-pink-600 transition"
      >
        Pago por página con Nequi

        <span className="block text-xs mt-2 font-normal">

          50 COP/página (1–99)
          <br />

          45 COP/página (100–499)
          <br />

          40 COP/página (500–999)
          <br />

          35 COP/página (1000+)

        </span>

        {pageCount && (
          <span className="block text-sm font-normal mt-1">

            {(() => {

              const getPricePerPage =
                (pages) => {

                if (pages >= 1000)
                  return 35;

                if (pages >= 500)
                  return 40;

                if (pages >= 100)
                  return 45;

                return 50;
              };

              const ppp =
                getPricePerPage(
                  pageCount
                );

              return (
                <>
                  {ppp} COP por página
                  <br />
                  Total:
                  {" "}
                  ${(pageCount * ppp)
                    .toLocaleString()}
                  {" "}
                  COP
                  {" "}
                  ({pageCount} páginas)
                </>
              );
            })()}

          </span>
        )}

      </button>

      {/* PayPal */}
      <button
        onClick={handlePagoPorPaginaPaypal}
        className="bg-blue-600 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 transition"
      >
        Pago por página con PayPal

        {pageCount && (
          <span className="block text-sm font-normal mt-2">

            {(() => {

              const getPricePerPage =
                (pages) => {

                if (pages >= 1000)
                  return 35;

                if (pages >= 500)
                  return 40;

                if (pages >= 100)
                  return 45;

                return 50;
              };

              const ppp =
                getPricePerPage(
                  pageCount
                );

              const totalCOP =
                pageCount * ppp;

              const totalUSD =
                (totalCOP / 4500)
                  .toFixed(2);

              return (
                <>
                  Total:
                  {" "}
                  ${totalUSD}
                  {" "}
                  USD
                  <br />
                  ({pageCount} páginas)
                </>
              );
            })()}

          </span>
        )}

      </button>

    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="bg-white shadow-md rounded-xl p-6">
        <h2 className="text-xl font-semibold text-blue-600 mb-4">Planes PayPal</h2>
        {planesPaypal.map((plan, index) => (
          <button
            key={index}
            onClick={() => handlePlanSeleccionado(plan, 'paypal')}
            className="w-full text-left bg-blue-50 hover:bg-blue-100 p-4 rounded-lg mb-2 transition"
          >
            {plan.name} - ${plan.price} USD
          </button>
        ))}
      </div>

      <div className="bg-white shadow-md rounded-xl p-6">
        <h2 className="text-xl font-semibold text-pink-600 mb-6">
          Planes Nequi
        </h2>

        <div className="grid gap-4">
          {planesNequi.map((plan, index) => {
            const destacado = plan.name.includes('Intermedio') && plan.name.includes('Mensual');

            return (
              <div
                key={index}
                className={`border rounded-xl p-5 transition
                  ${destacado
                    ? 'border-pink-500 bg-pink-50 shadow-lg'
                    : 'border-gray-200 bg-white'}
                `}
              >
                {destacado && (
                  <div className="text-xs font-semibold text-pink-600 mb-2">
                    ⭐ MÁS RECOMENDADO
                  </div>
                )}

                <div className="text-lg font-semibold text-gray-800">
                  {plan.name}
                </div>

                <div className="text-sm text-gray-600 mb-2">
                  {plan.pages.toLocaleString()} páginas incluidas
                </div>

                <div className="text-2xl font-bold text-gray-900 mb-1">
                  ${plan.priceLabel} COP
                </div>

                <div className="text-sm text-gray-700 mb-4">
                  Precio por página: <b>{plan.precio_por_pagina} COP</b>
                </div>

                <button
                 
                  onClick={() => handlePlanSeleccionado(plan)}
                  className={`w-full py-2 rounded-lg font-semibold transition
                    ${destacado
                      ? 'bg-pink-600 text-white hover:bg-pink-700'
                      : 'bg-gray-800 text-white hover:bg-gray-900'}
                  `}
                >
                  Elegir plan
                </button>
              </div>
            );
          })}
        </div>
      </div>


      </div>
      </>
    )}

    {selectedOption?.currency === 'COP' && (
      <>
        {showNequiModal && waitingNequi && (
          <NequiPaymentModal onClose={() => setShowNequiModal(false)} />
        )}

        {waitingNequi ? (
          <p className="text-yellow-600 font-semibold mt-4">
            Esperando confirmación desde tu App Nequi...
            <br />
            Por favor sigue las instrucciones de la ventana emergente.
          </p>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <input
              type="text"
              placeholder="Ingresa tu número Nequi"
              value={nequiPhone}
              maxLength={10}
              onChange={(e) => setNequiPhone(e.target.value.replace(/\D/g, ''))}
              className="border border-gray-300 p-3 rounded-xl text-center w-64 focus:ring focus:ring-pink-300"
            />

            <button
              onClick={handleNequiPayment}
              disabled={waitingNequi}
              className="transition hover:opacity-90"
            >
              <img
                src={nequiButImg}
                alt="Botón de pago Nequi"
                className="mx-auto w-52 md:w-64"
              />
            </button>

            <button
              onClick={checkPaymentStatus}
              disabled={!transactionId || checkingStatus || !canCheckStatus}
              className="w-full px-4 py-3 mt-3 bg-blue-500 text-white rounded-xl hover:bg-blue-600 disabled:bg-gray-400"
            >
              {checkingStatus ? "Verificando..." : "🔄 Verificar estado del pago"}
            </button>
          </div>
        )}
      </>
    )}

    {selectedOption?.currency === 'USD' && (

      <div className="mt-8">

        <div
          id="paypal-button-container"
          className="max-w-md mx-auto"
        />

      </div>

    )}

    <div className="mt-10">
      <button
        onClick={handleExtractText}
        disabled={
          (
            !extractionEnabled &&
            !hasAvailablePages
          ) || loading
        }
        className={`w-full md:w-1/2 mx-auto px-6 py-3 rounded-xl font-semibold text-white ${
          loading ||
          (
            !extractionEnabled &&
            !hasAvailablePages
          )
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-green-500 hover:bg-green-600'
        } transition`}
      >
        {loading ? 'Extrayendo texto...' : 'Extraer Texto del PDF'}
      </button>
    </div>
  </div>
);
}


export default ExtractTextPageLogin;


